import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {MatchResolver} from '@core/services/match-resolver.service';
import {MatchLineupTabComponent} from '@modules/game-detail/pages/match-lineup-tab/match-lineup-tab.component';
import {MatchDetailWrapperComponent} from '@modules/game-detail/pages/match-detail-wrapper/match-detail-wrapper.component';
import {MatchOverviewTabComponent} from '@modules/game-detail/pages/match-overview-tab/match-overview-tab.component';
import {MatchLiveTickerTabComponent} from '@modules/game-detail/pages/match-live-ticker-tab/match-live-ticker-tab.component';
import {MatchVideosTabComponent} from '@modules/game-detail/pages/match-videos-tab/match-videos-tab.component';
import {GameDetailRoutes} from '@app/routes/game-detail.routes';

export const routes: Routes = [
  {
    path: '',
    component: MatchDetailWrapperComponent,
    resolve: { match: MatchResolver },
    children: [
      { path: '', redirectTo: GameDetailRoutes.liveTicker, pathMatch: 'full' },
      { path: GameDetailRoutes.overview, component: MatchOverviewTabComponent },
      { path: GameDetailRoutes.liveTicker, component: MatchLiveTickerTabComponent },
      { path: GameDetailRoutes.videos, component: MatchVideosTabComponent },
      { path: GameDetailRoutes.lineup, component: MatchLineupTabComponent },
    ],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GameDetailRouting { }
